<template>
	<div class="">
		<div class="custom-loader-wrapper" v-if="loader">
			<div class="text-center">
				<span class="d-block max-450">
					We are processing your download and this may take some time. Do not close this window until the download begins.
				</span>
				<img v-bind:src="$api_url+'/public/images/download-loader.svg'" class="loader-logo" width="100px"/>
				<p class="mt-5">
					Plesae click
					<a target="_blank" :href="$api_url+'/company/dashboard'">here</a>
					or below if you want to continue surfing the system.
				</p>
				<b-button class="mb-1" target="_blank" :href="$api_url+'/company/dashboard'">
					Dashboard
				</b-button>
			</div>
		</div>

        <div class="row col-12 no-margin px-0">
            <div class="ibox col-md-12">
                <div class="ibox-title dashboard_title">
                    <h4 class="clearfix">
                        <span class="float-left">GF Overview</span>
                        <span class="float-right">
                            
                        </span>
                    </h4>
                    
								
                </div>
                
                <div class="ibox-content pf-overview">
                    <div class="payslip-details-info-inner row">
                        <template  v-if="employee_info.length == 0">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                                <div class="no-result-cell text-center">
                                    <img v-bind:src="$api_url+'/public/images/download-loader.svg'" class="loader-logo pf-statement-overview-loader"/>
                                </div>
                            </div>
                        </template>
                        <template v-else>
                            <div class="col-md-4 payslip-details-info-right">
                                <div class="wrapper">
                                    <div class="first">Employee ID</div>
                                    <div class="second">{{employee_info.joining_date}}</div>
                                </div>
                            </div>

                            <div class="col-md-4 payslip-details-info-right">
                                <div class="wrapper">
                                    <div class="first">Employee Name</div>
                                    <div class="second">{{employee_info.employee_name}}</div>
                                </div>
                            </div>
                            <div class="col-md-4 payslip-details-info-right">
                                <div class="wrapper">
                                    <div class="first">Job Position</div>
                                    <div class="second">{{employee_info.jobposition}}</div>
                                </div>
                            </div>

                            <div class="col-md-4 payslip-details-info-right">
                                <div class="wrapper">
                                    <div class="first">Joining Date</div>
                                    <div class="second">{{employee_info.joining_date}}</div>
                                </div>
                            </div>
                            
                            <div class="col-md-4 payslip-details-info-right">
                                <div class="wrapper">
                                    <div class="first">Service Period</div>
                                    <div class="second">{{employee_info.service_preiod}}</div>
                                </div>
                            </div>

                            <div class="col-md-4 payslip-details-info-left">
                                <div class="wrapper">
                                    <div class="first">GF Enrollment Date</div>
                                    <div class="second">{{employee_info.GF_enrollment_date}}</div>
                                </div>
                            </div>

                            <div class="col-md-4 payslip-details-info-right">
                                <div class="wrapper">
                                    <div class="first">Opening Balance of Fund</div>
                                    <div class="second">{{formatMoney(employee_info.opening_balance)}}</div>
                                </div>
                            </div>

                            <div class="col-md-4 payslip-details-info-right">
                               
                                <div class="wrapper">
                                    <div class="first">GF Membership Period</div>
                                    
                                    <div class="second">{{employee_info.GF_membership_period}}</div>
                                </div>
                            </div>
                            
                            <div class="col-md-4 payslip-details-info-left">
                                <div class="wrapper">
                                    <div class="first">Closing Balance of Fund</div>
                                    <div class="second">
                                        <template v-if="employee_info.closing_balance_of_fund != undefined"> 
                                            {{formatMoney(employee_info.closing_balance_of_fund)}}
                                        </template>
                                    </div>
                                </div>
                            </div>
                            
                        </template>
                    </div>
                    
                </div> 
            </div>
            <div class="ibox col-md-12 border-0">
                <div class="ibox-title dashboard_title company-form-box-title pf-contribution">
                    <h4 class="clearfix">
                        <span class="float-left">Employees Gratuity Fund Scheme<span class="title-sub-text">A comprehensive overview of an employee's contributions and balance in their gratuity fund account.</span></span>
                        <span class="float-right">
                            <select id="year" v-model="year" name="year" class="form-control custom-select text-center">
                                <option  :value='sa'>Year</option>
                                <template v-if="gf_settings.gf_year_end.opt_value != 12">
                                    <option v-for='pyr in payrunyears'  :value='pyr'>{{ pyr }}</option>		
                                </template>	
                                <template v-else>
                                    <option v-for='pyr in f_y'  :value='pyr'>{{ pyr }}</option>		
                                </template>
                            </select> 
                        </span>
                        
                    </h4>
                    
                </div>
                <div class="ibox-content">
                    <b-overlay  rounded="sm">
                        <template>
                            <div v-if="details.length == 0" class="px-3 py-3 no-result-cell text-center">
                                <span class="d-block text-center">
                                    {{empty_result}}
                                </span>
                                <img v-bind:src="$api_url+'/public/images/download-loader.svg'" class="loader-logo" width="100px"/>
                            </div>
                            <div v-else class="overflow-auto">
                                <table class="table ">
                                        <thead class="" style="">
                                            <tr class="table-head" v-for="(detail, index) in details.data" :key="detail.employee_id">
                                                <template v-if="index < 1">
                                                    <template v-for="(v,i,count) in detail">
                                                        <td class="text-center" v-if="i == 'contribution_year' || i== 'contribution_month' || i== 'type' || i== 'Designation' || i== 'Employee Id' ||  column_selected.includes(i) ">
                                                            <template>
                                                                {{ replaceTableHeads(i) }}
                                                            </template>
                                                        </td>
                                                        <td class="text-center" v-else-if="i == 'monthly_salary' || i== 'employee_contribution' || i== 'company_contribution' || i== 'settlement' || i== 'forfeiture' || i== 'closing_balance'  " >
                                                            <template>
                                                                {{ replaceTableHeads(i) }}
                                                            </template>
                                                        </td>
                                                        <td class="text-center pf_slip_head" v-else-if="i == 'gf_slip' ">
                                                            <template>
                                                                GF Slips
                                                            </template>
                                                        </td>
                                                    </template>
                                                    
                                                </template>
                                            </tr>
                                        </thead>
                                        <tbody class="pf-contribution-table-body">
                                            <tr style="display: none;">
                                            </tr>
                                            <tr class="table-row hover-bg " v-for="detail in details.data" :key="detail.employee_id">
                                                <!--aboni 10-11-21-->

                                                <template v-if="filterFiscalYear(detail.contribution_year,detail.contribution_month)">
                                                    <template v-for="(v,i,count) in detail">
                                                        <td class="2" v-if="i == 'contribution_year' || i== 'contribution_month' || i== 'type' || i== 'Designation' || i== 'Employee Id' ||  column_selected.includes(i) ">
                                                            {{v}}
                                                        </td>
                                                        <td class="2 text-right" v-else-if="i == 'monthly_salary' || i== 'employee_contribution' || i== 'company_contribution' || i== 'settlement' || i== 'forfeiture' || i== 'closing_balance'  ">
                                                            <div v-if="v==0">
                                                                --
                                                            </div>
                                                            <div v-else>
                                                                {{formatMoney(v)}}
                                                            </div>
                                                        </td>

                                                        <td class="2 text-center px-0" style="width: 140px;" v-else-if="i == 'gf_slip' ">
                                                            <div v-if="v==0">
                                                                --
                                                            </div>
                                                            <div v-else>

                                                                <div class="text-uppercase align-self-center text-center">
                                                                    <b-link @click="showGFSlipModal(detail)">
                                                                        <img :src="$api_url+'/public/images/download_image.png'"  class="" /> 
                                                                    </b-link>
                                                                </div>
                                                        
                                                            </div>
                                                        </td>
                                                    </template>
                                                </template>
                                                
                                               
                                                <!--aboni 10-11-21-->
                                            </tr>
                                        </tbody>
                                </table>
                            </div>
                        </template>

                    </b-overlay>

                    <h4 class="clearfix">
                        <span class="float-left">
                            <!-- <b-button class="mt-3  custom-primary" @click="showInterestWaiverForm()">
                                Interest Waiver
                            </b-button> -->
                        </span>
                        <span class="float-right">
                            <b-button class="mt-3" @click="getEmployeeGfReport()">
                                Download Report
                            </b-button>
                        </span>
                    </h4>
                </div>
            </div>
        </div>

        <b-modal id="bv-modal-process-waiver" size="md" hide-footer  title="Interest Waiver Form">
            <gf-interest-waiver-form :employee_info="employee_info" :key="waiver_key" :pageurl="$api_url" :store_scope="store_scope"  v-on:childToParent="waiverReturn"></gf-interest-waiver-form>
        </b-modal>


        <b-modal id="bv-modal-process-statement" size="md" hide-footer  title="Download GF Statement">
            <gf-statement-download-form :employee_info="employee_info" :key="waiver_key" :pageurl="$api_url" :store_scope="store_scope"  v-on:childToParent="statementReturn"></gf-statement-download-form>
        </b-modal>


        <b-modal id="bv-modal-gf-slip" size="lg" hide-footer  title="GF Slip">
            <Employeegfslipdetails :pageurl="$api_url" :payslip="pay_slip_details.payslip_id" :company="employee_info.company_name"  :pmonth="pay_slip_details.contribution_month" :pyear="pay_slip_details.contribution_year" :dynamic_fields="dynamic_fields" :payslipname="'GF Slip for '+employee_info.employee_name+' - '+pay_slip_details.contribution_month+' '+pay_slip_details.contribution_year"></Employeegfslipdetails>
        </b-modal>
        
        <!-- <Employeegfslipdetails :pageurl="pgurl" :payslip="payslip.id" :company="companies[payslip.company_id]"  :pmonth="payslip.month" :pyear="payslip.year" :dynamic_fields="dynamic_fields" :payslipname="'GF Slip for '+empdata.name+' - '+payslip.month+' '+payslip.year" :emp_etin="empdata.etin" :emp_department="payslip.department" :emp_jobposition="payslip.jobposition" :emp_code="emp_public_info.employee_code" :emp_joining="emp_joinng_date" :emp_branch="payslip.branch_name"></Employeegfslipdetails> -->
	</div>
</template>

<script>
    
    
    export default{
        
        mounted() {
            this.$refs.trzcalendar;
        },
        props: ['pageurl' , 'flag'],   
        components: {
            
        },     
        data(){
            
            return {
                company_name: '',
                pageUrl:this.$api_url,
                
                search:'',
                length: 100,
                pagination: {currentPage: 1, pages:1},

                empty_result : 'Please hold tight! We are preparing the report data for you!',

                fiscal_year : '',
                
                payroll_reporting_data : [],
                details : [],
                showoverlay : true,
                loader: false,
                /***Ali */

                column_selected:[],
                column_options:[],
                default_fields:[],
                column_selected_view:[],
                show_selected:'',
                /**Child Component property data */
                is_action:1,
                checkbox:0, 
                list_key:0,
                custom_list:[],   
                default_column:['name','employee_code'],
                appended_column:[
                    { value: "gf_start", text: "GF Start Date",type: "date"},
                    { value: "gf_total", text: "Total Balance",type: "number"},
                ],
                primary_key:'employee_id', 
                company_options:[],
                tmp_custom_list:[],
                custom_array:[],
                /***Child Component property data */
                empty_result : 'Fetching Data!',
                 curr_emp_gf_total:0,
                curr_emp_monthly_gf_total:{},
                gfoverlay: true, 
                empdata: [],
                m_search_data: [],
                emp_gf_title: '',
                emp_btn_title: '',
                notice: "",
                blankmsg : 'Fetching data..',
                people:0,
                c_date:'',
                c_time:'',
                gf_type:0,
                curr_emp_mgf_total:{},
                gf_types: [
                    { value: "0", text: "Registered" },
                    { value: "1", text: "Unregistered" }
                ],
                action_loader: false,
                report_data:[],
                employee_info:[],
                showWaiverForm:false,
                store_scope:'front',
                gf_settings :{gf_profit_waive_feature:{ opt_value: 0, status: 0 },gf_year_end:{ opt_value: 0, status: 0 },},
                waiver_key:0,
                dynamic_fields:{},
                emp_name:'',
                pay_slip_details:[],
                payrunyears: [],
                f_y:[],
                year: '', 
            }
        },
        methods:{
            getGFReportHeaderInfo: function(){
              axios.get(this.$api_url+'/gfreport/header')
              .then(function (response) {
                 this.company_name = response.data.company_name;
                 this.c_date = response.data.curr_date;
                 this.c_time = response.data.curr_time;
                 this.gf_type = response.data.gf_type;
                 
                 
              }.bind(this));
         
            },
            filterFiscalYear(year,month)
            {

                const monthNames = [
                    'January', 'February', 'March', 'April', 'May', 'June',
                    'July', 'August', 'September', 'October', 'November', 'December'
                ];
                
                const monthIndex = monthNames.findIndex(name => name.toLowerCase() === month.toLowerCase());
                
                if(this.gf_settings.gf_year_end.opt_value != 12)
                {
                    const fiscalYearParts = this.year.split('-');
                    const fiscalYearStart = parseInt(fiscalYearParts[0]);
                    const fiscalYearEnd = parseInt(fiscalYearParts[1]);

                    // Parse the date string into a Date object
                    
                    const dateMonth = monthIndex + 1; // JavaScript Date object uses 0-indexed months
                    const dateYear = parseInt(year);
                    const date = new Date(dateYear, dateMonth);

                    // Check if the date is within the fiscal year
                    const fiscalYearStartMonth = 7; // Fiscal year starts on April 1st
                    const fiscalYearStartDate = new Date(fiscalYearStart, fiscalYearStartMonth);
                    const fiscalYearEndMonth = 6; // Fiscal year ends on March 31st
                    const fiscalYearEndDate = new Date(fiscalYearEnd, fiscalYearEndMonth, 31);


                    return date >= fiscalYearStartDate && date <= fiscalYearEndDate;
                    return 0;
                }
                else
                {
                    
                    const fiscalYearParts = this.year;
                    const fiscalYearStart = parseInt(fiscalYearParts);
                    const fiscalYearEnd = parseInt(fiscalYearParts);

                    // Parse the date string into a Date object
                    
                    const dateMonth = monthIndex + 1; // JavaScript Date object uses 0-indexed months
                    const dateYear = parseInt(year);
                    const date = new Date(dateYear, dateMonth);

                    // Check if the date is within the fiscal year
                    const fiscalYearStartMonth = 1; // Fiscal year starts on April 1st
                    const fiscalYearStartDate = new Date(fiscalYearStart, fiscalYearStartMonth);
                    const fiscalYearEndMonth = 12; // Fiscal year ends on March 31st
                    const fiscalYearEndDate = new Date(fiscalYearEnd, fiscalYearEndMonth, 31);


                    return date >= fiscalYearStartDate && date <= fiscalYearEndDate;
                    return 0;
                }
                
            },
            getGFSettings: function()
            { 
                
                let currentObj = this;
                axios.get(this.$api_url+'/gf/getsettings').then(function (response) {
                    currentObj.gf_settings = response.data.data;
                   
                        
                })  
                .catch(function (error) {
                console.log(error);
                });
                
            },
            showGFSlipModal: function(slip_detail)
            {
                
                this.pay_slip_details = slip_detail;
                console.log(this.employee_info);
                this.$bvModal.show('bv-modal-gf-slip');
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            replaceTableHeads(val){
                val = val.replace(/_/g, ' ');
                
                val = val.toLowerCase().split(' ');
                for(var i = 0; i < val.length; i++){
                    val[i] = val[i].charAt(0).toUpperCase() + val[i].substring(1);     
                }
                return val.join(' ');
            },
            showInterestWaiverForm: function()
            {
                this.waiver_key += 1;
                this.showWaiverForm = true;
                this.$bvModal.show('bv-modal-process-waiver');
            },
            showStatementDownloadForm: function()
            {
                this.waiver_key += 1;
                this.showStatementForm = true;
                this.$bvModal.show('bv-modal-process-statement');
            },
            download_file(fileURL) 
            {
                if(!this.checkNet()) return false;
                
                var fileName = fileURL.substring(fileURL.lastIndexOf('/')+1);
                if (!window.ActiveXObject) {
                    var save = document.createElement('a');
                    save.href = fileURL;
                    save.target = '_blank';
                    //var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
                    save.download = fileName || filename;
                    if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
                            document.location = save.href;
                        }else{
                            var evt = new MouseEvent('click', {
                                'view': window,
                                'bubbles': true,
                                'cancelable': false
                            });
                            save.dispatchEvent(evt);
                            (window.URL || window.webkitURL).revokeObjectURL(save.href);
                        }    
                }
                else if ( !! window.ActiveXObject && document.execCommand)     {
                    var _window = window.open(fileURL, '_blank');
                    _window.document.close();
                    _window.document.execCommand('SaveAs', true, fileName || fileURL)
                    _window.close();
                }
            },
            
            stringView(str) 
            {
                var i, frags = str.split('_');
                for (i=0; i<frags.length; i++) {
                    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
                }
                return frags.join(' ');
            },
            gfDetailsNew: function()
            { 
                
                let currentObj = this;
                
                let formData = new FormData();
                
                formData.append('viewmode', 1);
                formData.append('front', 1);
                formData.append('d_type', 'excel'); 
                formData.append('data_front', 'yes'); 
                formData.append('year', this.year);
                this.gfoverlay = true;
                this.report_data = [];
                this.details = [];
                this.employee_info = [];

                currentObj.showoverlay = true;
                
                axios.post(this.$api_url + '/downloadgfreport_custom', formData)
                                    .then(function (response) 
                                    {
                                        currentObj.report_data = response.data.file_name;
                                        currentObj.employee_info = response.data.file_name.employee_info;
                                       
                                        currentObj.details = response.data.file_name.data;
                                        currentObj.showoverlay = false;
                                        currentObj.gfoverlay = true;
                                        this.getPayslipDynamicFieldData(this.employee_info.employee_id);
                                        this.getEmployeeActiveYearlist(this.employee_info.employee_id);
                                    }.bind(this))
                                    .catch(function (error) 
                                    {
                                        currentObj.showoverlay = false;
                                        console.log(error);
                                    }); 



            }, 
           
            getGfMonthlyTotalContribution: function(gf_cont_data)
            {
                
                if(gf_cont_data.length>0)
                {

                    let gf_employer_total = 0.00;
                    let gf_employee_total = 0.00;
                    let gf_profit_total = 0.00;
                    let gf_forfieture_total = 0.00;
                    let gf_loan_availed_total = 0.00;
                    let gf_loan_refund_total = 0.00;
                    let gf_settlement_total = 0.00;
                
                    for(let i=0; i < gf_cont_data.length; i++)
                    {

                        let gf_employer = parseFloat(this.toMoney(gf_cont_data[i].gf_employer));
                        let gf_employee = parseFloat(this.toMoney(gf_cont_data[i].gf_employee));
                        let gf_profit = parseFloat(this.toMoney(gf_cont_data[i].gf_profit));
                        let gf_forfieture = parseFloat(this.toMoney(gf_cont_data[i].gf_forfieture));
                        let gf_loan_availed = parseFloat(this.toMoney(gf_cont_data[i].gf_loan_availed));
                        let gf_loan_refund = parseFloat(this.toMoney(gf_cont_data[i].gf_loan_refund));
                        let gf_settlement = parseFloat(this.toMoney(gf_cont_data[i].gf_settlement));
                        
                        

                        gf_employer_total += gf_employer;
                        gf_employee_total += gf_employee;
                        gf_profit_total += gf_profit;
                        gf_forfieture_total += gf_forfieture;
                        gf_loan_availed_total += gf_loan_availed;
                        gf_loan_refund_total += gf_loan_refund; 
                        gf_settlement_total += gf_settlement; 

                    }


                    this.curr_emp_monthly_gf_total.gf_employer = gf_employer_total + this.curr_emp_mgf_total.gf_employer;
                    this.curr_emp_monthly_gf_total.gf_employee = gf_employee_total + this.curr_emp_mgf_total.gf_employee;
                    this.curr_emp_monthly_gf_total.gf_profit = gf_profit_total;
                    this.curr_emp_monthly_gf_total.gf_forfieture = gf_forfieture_total;
                    this.curr_emp_monthly_gf_total.gf_loan_availed = gf_loan_availed_total;
                    this.curr_emp_monthly_gf_total.gf_loan_refund = gf_loan_refund_total;
                    this.curr_emp_monthly_gf_total.gf_settlement = gf_settlement_total;
                    
                }

            },
            getMigratedGfTotalContribution: function(mgf_cont_data)
            {
                let mgf_employer_total = 0.00;
                let mgf_employee_total = 0.00;

                if(mgf_cont_data.length>0)
                {
                    
                    
                        for(let i=0; i < mgf_cont_data.length; i++)
                        {
                            
                            let mgf_employer = parseFloat(this.toMoney(mgf_cont_data[i].employer_contribution));
                            let mgf_employee = parseFloat(this.toMoney(mgf_cont_data[i].employee_contribution));
                            
                            mgf_employer_total += mgf_employer;
                            mgf_employee_total += mgf_employee;
    
                        }
                    
                }
                this.curr_emp_mgf_total.gf_employer = mgf_employer_total;
                this.curr_emp_mgf_total.gf_employee = mgf_employee_total;
                

            },
           formatMoney: function(amount)
            {
                var money = Number(amount);

                if(this.$atl_company_number_format == 'no')
                {
                    money = Math.round(money);
                    money = money.toLocaleString();
                }
                else
                {
                    money = money.toLocaleString();
                    if(money=='NaN')
                    money = amount;
                    else{
                    if(money.indexOf(".")<0)
                    money = money+".00";
                    }

                }
                
                return money;
            }, 
           toMoney: function(amount)
            {
                if(amount !="0")
                {
                        if(!isNaN(amount))
                        {
                            var number = Number(amount);
                            return number;
                        }
                    var NumWithoutCommas = amount.replace(/,/g, ''); 
                    var number = Number(NumWithoutCommas).toFixed(2);
                    return number;
                }else
                    return amount;
            },
           getEmployeeGfReport: function()
            { 
            
            var curr_obj = this;
            
            let formData = new FormData();
            
            formData.append('d_type', 'excel'); 
            formData.append('data_front', 'yes'); 
            this.loader = true;
            axios.post(this.$api_url + '/downloadgfreport_custom', formData)
                                .then(function (response) 
                                {
                                    this.loader = false;
                                    
                                    this.download_file(response.data.file_name);
                                }.bind(this))
                                .catch(function (error) 
                                {
                                    currentObj.errormsg = error.response.data.errors;
                                }); 

                

            }, 
            capitalizeTheFirstLetterOfEachWord(words) {
            var separateWord = words.toLowerCase().split(' ');
            for (var i = 0; i < separateWord.length; i++) {
                separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
                separateWord[i].substring(1);
            }
            return separateWord.join(' ');
            },
            waiverReturn()
            {
                this.gfDetailsNew();
                this.showWaiverForm = false;
                this.$bvModal.hide('bv-modal-process-waiver');
            },
            statementReturn()
            {
                this.showStatementForm = true;
                this.$bvModal.hide('bv-modal-process-statement');
            },
            getPayslipDynamicFieldData:function(emp_id) 
            { 
                axios.get(this.$api_url+'/company/payslip-field-settings/get-employee-dynamic-field-data', {
                            params: {
                                employee_id: emp_id
                            }
                    }).then(function(response){
                        var ltData = response.data;
                        this.dynamic_fields =ltData;

                        console.log(this.dynamic_fields);
                    
                }.bind(this));
            },
            getpayrunyears: function()
			{

						axios.get(this.$api_url+'/getpayrun-years' , {
							params: {
								page: 1,
								per_page: 10,
								search_query: this.search,
								search_query_by_id: '',
							}
					}).then(function(response){
					this.payrunyears = response.data;
					
					console.log(this.payrunyears[0].range);


				}.bind(this));
			},
            get_current_fiscal_year: function()
            {
                // 
                if(!this.checkNet()) return false;
                axios.get(this.$api_url+'/getcurrentfiscalyear' , {
                }).then(function(response){
                    this.year= response.data;
                    this.gfDetailsNew();
                    
                }.bind(this));
            },
            getEmployeeActiveYearlist:function(employee_id)
            {        
                 
                if(!this.checkNet()) return false;

                    axios.get(this.$api_url+'/gf/employee-active-year-list' , {
                        params: {
                            employee_id: employee_id
                        }
                    })
                    .then(function(response){
                        this.respData = response.data;
                        
                        if(this.respData.fiscal_year.length > 0) 
                        {
                            this.payrunyears = this.respData.fiscal_year;
                            this.f_y = this.respData.year;
                            if(this.gf_settings.gf_year_end.opt_value != 12)
							{
								this.year= this.payrunyears[0];
							}
							else
							{
								this.year= this.f_y[0];
							}
                        }
                        else
                        {
                            this.statememt_available = false;
                        }
                        this.showoverlay = false;
                        
                    }.bind(this)).catch(function (error){alert(error)});

               
               
            },   

        },
        
                
        created: function(){
            
            this.getGFReportHeaderInfo();
            
            this.getGFSettings();
            //this.getpayrunyears();
            this.get_current_fiscal_year();
        },
        computed: 
        {
            
            
        }
    }
</script>
